module.exports = __webpack_public_path__ + "img/form-view-help.0107765a.png";